/**
 * Module: LazyLoadingHelper
 *
 * Calls Utility.isElementInViewIO in order to add Lazyloading
 *
 *
 * Returned Functions: Init
 *
 * CallBack Function sent to IsElementInViewIO
 *
 * 1.loadImage
 * 2.loadPicture
 * 3.loadVideo
 *
 */

var Acr = Acr || {};

Acr.LazyLoadingHelper = (function () {


  function init() {

    if ('loading' in HTMLImageElement.prototype) {
      const images = document.querySelectorAll('img[loading="lazy"]');
      images.forEach(img => {
        img.src = img.dataset.src;
      });
    } else {
      var imagesToLoad = [].slice.call(document.querySelectorAll('img[loading="lazy"]'));
      Utility.initLazyLoadingIO(imagesToLoad, loadImage);
    }

    var videosToLoad = [].slice.call(document.querySelectorAll('video.lazy'));
    Utility.initLazyLoadingIO(videosToLoad, loadVideo);

  }

  /** ********************************** */
  /*
  /* isLazyLoadingNative
  /* Return true if browser supports loading=lazy native
  /*
  /******************************************************** */
  function isLazyLoadingNative() {
    return 'loading' in HTMLImageElement.prototype;
  }

  function loadImage(element) {
    if (element.dataset.srcset !== undefined) {
      element.srcset = element.dataset.srcset;
    }
    element.src = element.dataset.src;
    element.removeAttribute('loading');
    Utility.reevaluatePictureFill();
  }

  function loadPicture(element) {
    var elementChildren = [].slice.call(element.querySelectorAll('source,img'));
    elementChildren.forEach(function (elementChild) {

      if (elementChild.dataset.srcset) {
        elementChild.setAttribute('srcset', elementChild.dataset.srcset);
      }

      if (elementChild.dataset.src) {
        elementChild.setAttribute('src', elementChild.dataset.src);
      }
    });
    element.removeAttribute('loading');
    Utility.reevaluatePictureFill();
  }

  function loadVideo(element) {
    for (var source in element.children) {
      var videoSource = element.children[source];
      var posterSource = element.dataset.poster;
      if (posterSource) {
        element.setAttribute('poster', posterSource);
      }
      if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
        videoSource.src = videoSource.dataset.src;
      }
    }

    element.load();
    element.classList.remove('lazy');
  }

  return {
    init: init,
    loadPicture: loadPicture,
    loadImage: loadImage,
    loadVideo: loadVideo,
    isLazyLoadingNative: isLazyLoadingNative,
  };
}());
